import { ReduxUtils } from '@dw/pwa-helpers/index.js';
import * as actions from './actions.js';

const INITIAL_STATE = { cards: {}, lastLanguage: null };

export const cardTranslateReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actions.TRANSLATE: {
      const translatedState = ReduxUtils.replace(state, `cards.${action.cardId}`, { language: action.lang });
      return ReduxUtils.replace(translatedState, 'lastLanguage', action.lang);
    }
    case actions.SHOW_ORIGINAL:
      // `lastLanguage` survives: it is the whole reason the menu can offer the reader's usual
      // language first on the next card.
      return ReduxUtils.replace(state, `cards.${action.cardId}`, undefined);
    default:
      return state;
  }
};
